import classNames from "classnames";
import { memo } from "react";
import * as dividerCss from "./divider.module.css";
import { Flex } from "./flex";
import { styleClasses, StyleProps } from "./styles";

export const Divider = memo(function Divider({
  classes,
  direction = "horizontal",
}: {
  classes?: string;
  direction?: "horizontal" | "vertical";
}) {
  if (direction === "vertical") {
    return (
      <Flex
        alignSelf="stretch"
        as="hr"
        borderColor="primary"
        borderLeftWidth="1px"
        borderStyle="solid"
        className={classNames(dividerCss.dividerVertical, classes)}
        data-arbiter="Divider"
        m="none"
        w="none"
      />
    );
  }
  return (
    <hr
      className={classNames(dividerCss.divider, classes)}
      data-arbiter="Divider"
    />
  );
});

interface DividerWithTextProps extends StyleProps {
  text: string;
}

export const DividerText = memo(function DividerText({
  text,
  ...props
}: DividerWithTextProps) {
  return (
    <div
      className={classNames(
        styleClasses({
          mx: "none",
          my: "md",
          textAlign: "center",
          textColor: "secondary",
          ...props,
        }),
        dividerCss.dividerText,
      )}
      data-arbiter="DividerText"
    >
      {text}
    </div>
  );
});
